class SkuVariantMedia {
  constructor() {
    this.gallery = document.querySelector('media-gallery');
    if (!this.gallery) return;

    this.variantInput = document.querySelector('input[name="id"]');
    if (!this.variantInput) return;

    // Grab all variants from Shopify Analytics meta
    this.variants =
      window.ShopifyAnalytics?.meta?.product?.variants || [];

    // Initial load
    this.updateByVariantId(this.variantInput.value);

    // Listen for variant changes
    this.variantInput.addEventListener('change', () => {
      this.updateByVariantId(this.variantInput.value);
    });
  }

  updateByVariantId(variantId) {
    const variant = this.variants.find(v => String(v.id) === String(variantId));
    if (!variant || !variant.sku) return;

    this.filterMediaBySku(variant.sku);
  }

  filterMediaBySku(sku) {
    const mediaItems = Array.from(this.gallery.querySelectorAll('[data-media-id]'));
    const thumbItems = Array.from(document.querySelectorAll('.thumbnail-list__item'));

    let firstVisibleMedia = null;

    // Hide/show main gallery
    mediaItems.forEach(item => {
      let itemSku = item.dataset.sku;

      // If no SKU (featured image) fallback to first item's data-sku
      if (!itemSku) itemSku = item.getAttribute('data-sku') || '';

      if (!itemSku || sku.includes(itemSku)) {
        item.classList.remove('hidden');
        if (!firstVisibleMedia) firstVisibleMedia = item;
      } else {
        item.classList.add('hidden');
        item.classList.remove('is-active'); // Remove active from hidden items
      }
    });

    // Make first visible media active
    if (firstVisibleMedia) firstVisibleMedia.classList.add('is-active');

    // Hide/show thumbnails
    thumbItems.forEach(thumb => {
      let itemSku = thumb.dataset.sku || '';
      if (!itemSku || sku.includes(itemSku)) {
        thumb.classList.remove('hidden');
      } else {
        thumb.classList.add('hidden');
      }
    });
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  new SkuVariantMedia();
});
